import { BoxItem } from './BoxItem'
import { BOX_COLORS, MIN_BOXES } from './constants'
import type { BoxListProps } from './types'

export function BoxList({ boxes, onContentChange, onRemove }: BoxListProps) {
  const canRemove = boxes.length > MIN_BOXES

  return (
    <div data-testid="box-list" className="space-y-4">
      {boxes.map((box, index) => {
        // Cycle through colors based on index
        const color = BOX_COLORS[index % BOX_COLORS.length]
        return (
          <BoxItem
            key={box.id}
            box={box}
            color={color}
            onContentChange={onContentChange}
            onRemove={onRemove}
            canRemove={canRemove}
          />
        )
      })}
    </div>
  )
}
